module.exports = __webpack_public_path__ + "img/transparent_next_img.3199976a.png";